import { nonUndefined, onlyUnique } from "Utility";
import { MatchSet } from "./Set/MatchSet";

export type TrackPick = {
  rosterId: string | undefined;
  pickType: PickType;
  trackId: string;
};

export type PickType = "Pick" | "Ban" | "Random";

export const getPlayablePicks = (set: MatchSet) => {
  const playablePicks = set.picks.filter(
    (p) => p.pickType === "Pick" || p.pickType === "Random"
  );
  const playedTrackIds = nonUndefined(
    set.tracks.map((t) => t.trackId).filter(onlyUnique)
  );

  for (let i = 0; i < playedTrackIds.length; i++) {
    const trackId = playedTrackIds[i];
    if (playablePicks.some((p) => p.trackId === trackId)) {
      continue;
    }

    playablePicks.push({
      pickType: "Random",
      rosterId: undefined,
      trackId,
    });
  }

  return playablePicks;
};

export const getBans = (picks: TrackPick[]) => {
  return picks.filter((p) => p.pickType === "Ban");
};

export const picksSequenceHasPicks = (picks: TrackPick[]) => {
  return picks.some((p) => p.pickType === "Pick");
};

export const picksSequenceHasBans = (picks: TrackPick[]) => {
  return picks.some((p) => p.pickType === "Ban");
};

export const trackWasPicked = (
  picks: TrackPick[],
  trackId: string,
  pickingTeamId?: string
) => {
  const pick = picks.find(
    (p) => p.trackId === trackId && p.pickType === "Pick"
  );
  if (!!pick && pickingTeamId !== undefined) {
    return pick.rosterId === pickingTeamId;
  }

  return !!pick;
};

export const trackWasBanned = (
  picks: TrackPick[],
  trackId: string,
  pickingTeamId?: string
) => {
  const ban = picks.find((p) => p.trackId === trackId && p.pickType === "Ban");
  if (!!ban && pickingTeamId !== undefined) {
    return ban.rosterId === pickingTeamId;
  }

  return !!ban;
};

export const getPickPosition = (picks: TrackPick[], trackId: string) => {
  if (!trackWasPicked(picks, trackId)) {
    return undefined;
  }

  const onlyPicks = picks.filter((p) => p.pickType === "Pick");
  const pick = onlyPicks.find((p) => p.trackId === trackId);
  return !!pick ? onlyPicks.indexOf(pick) + 1 : undefined;
};

export const trackPickedWhenAvailable = (
  picks: TrackPick[],
  trackId: string
) => {
  const firstPick = picks.find((p) => p.pickType === "Pick");
  if (!firstPick) {
    return undefined;
  }

  const firstPickIdx = picks.indexOf(firstPick);
  const prePicks = picks.slice(0, firstPickIdx);
  if (prePicks.find((p) => p.trackId === trackId) !== undefined) {
    return undefined;
  }

  return (
    picks.find((p) => p.trackId === trackId && p.pickType === "Pick") !==
    undefined
  );
};
